import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoginCredentialsDisplayComponent } from '../login-credentials-display/login-credentials-display.component';
import { LoginCredentialsEditComponent } from '../login-credentials-edit/login-credentials-edit.component';
import { filter } from 'rxjs';
import { CustomerService } from '@core';
import { Customer } from '@models/customer';
import { toSignal } from '@angular/core/rxjs-interop';
import { PortalCollapsibleComponent } from '../../portal-collapsible/portal-collapsible.component';

@Component({
    selector: 'app-login-credentials-collapsible',
    templateUrl: './login-credentials-collapsible.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PortalCollapsibleComponent, LoginCredentialsDisplayComponent, LoginCredentialsEditComponent],
})
export class LoginCredentialsCollapsibleComponent {
    private customerService = inject(CustomerService);

    private customer$ = this.customerService.customer$.pipe(filter((res) => res !== null));
    protected customer = toSignal(this.customer$);

    protected editMode = false;

    protected toggleEditMode(): void {
        this.editMode = !this.editMode;
    }

    protected updateCustomer(newCustomer: Customer): void {
        this.customerService.customer = newCustomer;
    }
}
